// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from 'react';

import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';

export const Breadcrumbs = () => (
  <BreadcrumbGroup
    expandAriaLabel="Show path"
    ariaLabel="Breadcrumbs"
    items={[
      { text: 'Platform', href: '#/platform' },
      { text: 'Applications', href: '#/applications' },
      { text: 'Create data streaming application', href: '#/create-data-streaming-application' },
    ]}
    onFollow={event => event.preventDefault()}
  />
);
